/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import {connect} from 'react-redux';
import { Button, Modal, ModalHeader, Container, ModalFooter } from 'src/components/Common/reactstrap/lib';
import InlineSVG from 'react-svg-inline';
import camera from 'src/imgs/camera.svg';
import styles from '../Orders.scss';// todo:extract to general
import * as ORDER_STATE from '../../../constants/orderStateConstatns';


class OrdersModalStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const value = this.props;
    let portionStates = value.portionStates,
      initStyle = 'col-2 bs-wizard-step ', done ='',
      status = 'В работе',
      statusStyle = 'text-info',
      step1 = 'disabled', step2 = step1, step3 = step1, step4 = step1, step5 = step1, step6 = step1;
    // todo: from step2 to step5: state > n ? 'complete' : 'disabled'; state == n && 'active'
    // when status will be stable do refactor
    switch (value.portionState) {
      case ORDER_STATE.ORDERED_BY_CUSTOMER:
        step1 = 'active';
        status = 'Заказан';
        break;
      case ORDER_STATE.REQUESTED_FROM_SUPPLIER:
        step1 = 'complete';
        step2 = 'active';
        status = 'Отправлен поставщику';
        break;
      case ORDER_STATE.APPROVED_BY_SUPPLIER:
        step1 = step2 = 'complete';
        step3 = 'active';
        status = 'Подтвержден поставщиком';
        break;
      case ORDER_STATE.EXPECTED_IN_STOCK:
        step1 = step2 = step3 = 'complete';
        step4 = 'active';
        status = 'Ожидается на складе ';
        break;
      case ORDER_STATE.IN_STOCK:
        step1 = step2 = step3 = step4 = 'complete';
        step5 = 'active';
        status = 'На складе ';
        break; //'В работе'
      case ORDER_STATE.SENDED_TO_CUSTOMER:
        step1 = step2 = step3 = step4 = step5 = step6 = 'complete';
        status = 'Готов к выдаче';
        statusStyle = 'text-success ';
        done = ' done';
        break; //Готов к выдаче
    }
    return (
      <div>

        <span className={statusStyle + ' text-link'} onClick={this.toggle}>{status}</span>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={value.className}>
          <ModalHeader toggle={this.toggle}>{status}</ModalHeader>
          <Container>
            <div className={styles.name}>
              <div>Заказ №  {value.orderId}</div>
              <div> {value.brandName} <a className="link" target="_blank" href={`search?article=${value.detailArticle}`}>{value.detailArticle}</a></div>
              <div>{value.detailName}</div>
            </div>
            <div className={'row bs-wizard' + done}>

              <div className={initStyle + step1}>
                <div className="text-center bs-wizard-stepnum"></div>
                <div className="progress"><div className="progress-bar"></div></div>
                <a href="#" className="bs-wizard-dot"></a>
                <div className="bs-wizard-info">
                  <p className={statusStyle}>{portionStates[ORDER_STATE.ORDERED_BY_CUSTOMER]}</p>
                  </div>
              </div>

              <div className={initStyle + step2}>
                <div className="text-center bs-wizard-stepnum"></div>
                <div className="progress"><div className="progress-bar"></div></div>
                <a href="#" className="bs-wizard-dot"></a>
                <div className="bs-wizard-info">
                  <p className={statusStyle}>{portionStates[ORDER_STATE.REQUESTED_FROM_SUPPLIER]}</p>

                </div>
              </div>

              <div className={initStyle + step3}>
                <div className="text-center bs-wizard-stepnum"></div>
                <div className="progress"><div className="progress-bar"></div></div>
                <a href="#" className="bs-wizard-dot"></a>
                <div className="bs-wizard-info">
                  <p className={statusStyle}>{portionStates[ORDER_STATE.APPROVED_BY_SUPPLIER]}</p>

                </div>
              </div>

              <div className={initStyle + step4}>
                <div className="text-center bs-wizard-stepnum"></div>
                <div className="progress"><div className="progress-bar"></div></div>
                <a href="#" className="bs-wizard-dot"></a>
                <div className="bs-wizard-info">
                  <p className={statusStyle}>{portionStates[ORDER_STATE.EXPECTED_IN_STOCK]}</p>

                </div>
              </div>
              <div className={initStyle + step5}>
                <div className="text-center bs-wizard-stepnum"></div>
                <div className="progress"><div className="progress-bar"></div></div>
                <a href="#" className="bs-wizard-dot"></a>
                <div className="bs-wizard-info">
                  <p className={statusStyle}>{portionStates[ORDER_STATE.IN_STOCK]}</p>

                </div>
              </div>
              <div className={initStyle + step6}>
                <div className="text-center bs-wizard-stepnum"></div>
                <div className="progress"><div className="progress-bar"></div></div>
                <a href="#" className="bs-wizard-dot"></a>
                <div className="bs-wizard-info">
                  <p className={statusStyle}>{portionStates[ORDER_STATE.SENDED_TO_CUSTOMER]}</p>

                </div>
              </div>
            </div>
          </Container>
        </Modal>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    portionStates: state.userReducer.portionStates
  })
)(OrdersModalStatus);



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/OrdersModalStatus.jsx
 **/